// extracted by mini-css-extract-plugin
module.exports = {"wrap":"OffersByDeal_wrap__3ivVA","card":"OffersByDeal_card__zG0si"};